<template>
  <div>
    <b-modal id="modal_process_background" hide-footer size="xl">
      <template #modal-title>
        Procesos agendados
      </template>

      <b-collapse visible>


        <div class="d-flex justify-content-end mb-3">
          <b-button variant="outline-primary" @click="_loadProccessBackground">
            <i class="fa fa-refresh mr-1"></i>
            Actualizar procesos agendados
          </b-button>
        </div>


        <b-table responsive striped hover :items="backgroundProcess" :fields="columns" bordered
                 thead-class="table-active"
                 show-empty empty-text="No hay resultados para mostrar.">


          <template v-slot:cell(estado_procesamiento)="data">
            <b-badge v-if="data.item.estado_procesamiento == 'PROCESANDO'" variant="warning"
                     v-text="data.item.estado_procesamiento"/>
            <b-badge v-else-if="data.item.estado_procesamiento == 'TERMINADO'" variant="success"
                     v-text="data.item.estado_procesamiento"/>
            <b-badge v-else variant="secondary"
                     v-text="data.item.estado_procesamiento ? data.item.estado_procesamiento : 'PENDIENTE'"/>
          </template>


          <template v-slot:cell(report_type)="data">
            {{ getNameInventoryType(data) }}
          </template>

          <template v-slot:cell(errores)="data">
            {{
              data.item.errores ? data.item.errores :
                  ! data.item.estado_procesamiento  || data.item.estado_procesamiento == 'PROCESANDO'
                      ? ''
                      : 'Sin errores'
            }}

          </template>

          <template v-slot:cell(downloadable)="data">
            <b-button
                variant="success"
                v-if="data.item.downloadable"
                @click="downloadFile(data.item)"
            >
              Descargar
            </b-button>
          </template>


        </b-table>


      </b-collapse>

      <br/>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <b-button @click="closeModal">
          <i class="fa fa-close fa-lg"></i>
          <span class="ml-1"> Cerrar</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {mapActions, mapState} from "vuex";

export default {
  name: "ModalShowProcessBackground",
  props: ['company_id', 'inventoryTypes'],
  data() {
    return {
      columns: [
        {key: 'downloadable', label: 'Descargable', sortable: true},
        {key: 'fecha_solicitud', label: 'Fecha de solicitud', sortable: true},
        {key: 'fecha_generacion', label: 'Fecha de generación', sortable: true},
        {key: 'report_type', label: 'Tipo de reporte', sortable: true},
        {key: 'errores', label: 'Errores del proceso', sortable: true},
        {
          key: "estado_procesamiento",
          label: "Estado de generación",
          sortable: true,
        },
      ],
    }
  },
  computed: {
    ...mapState("background_processes", ['backgroundProcess']),
    ...mapState('productos', ['filtro']),
  },
  methods: {
    ...mapActions("background_processes", ['loadProccessBackground', 'downloadReport']),
    closeModal() {
      this.$bvModal.hide('modal_process_background');
    },
    async _loadProccessBackground() {
      await this.loadProccessBackground({type: 'REPORTE-INVENTARIO', company_id: this.company_id});
    },
    async downloadFile(item) {
      await this.downloadReport(item)
    },
    /**
     * Consultar el nombre del tipo de reporte.
     * @param {*} data
     * @author Fernando Claros
     */
    getNameInventoryType(data) {

      let currentCode = '';
      if ('json' in data.item) {

        if (typeof data.item.json.report_type === 'object' && 'name' in data.item.json.report_type)
          currentCode = data.item.json.report_type['name'];
        else currentCode = data.item.json.report_type;

      }

      const item = this.inventoryTypes.find(item => item.code == currentCode);
      if (item) return item.name;

      return 'N/A';
    }
  },
}

</script>
